import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

import Layout from '@/views/Layout/index.vue'
import Login from '@/views/Login/index.vue'
import Dashboard from '@/views/Dashboard/index.vue'
import Products from '@/views/Products/index.vue'
import Review from '@/views/Review/index.vue'
import PuhuiOrders from '@/views/PuhuiOrders/index.vue'
import ReportOrders from '@/views/ReportOrders/index.vue'
import OrderDetail from '@/views/Orders/OrderDetail.vue'
import Members from '@/views/Members/index.vue'
import Accounts from '@/views/Accounts/index.vue'
import Finance from '@/views/Finance/index.vue'
import Leaderboard from '@/views/Leaderboard/index.vue'
import MerchantAudit from '@/views/MerchantAudit/index.vue'
import AfterSales from '@/views/AfterSales/index.vue'
import AfterSaleDetail from '@/views/AfterSales/detail.vue'
import CloudWarehouse from '@/views/CloudWarehouse/index.vue'
import SystemAdmins from '@/views/System/Admins.vue'
import SystemRoles from '@/views/System/Roles.vue'
import SystemPermissions from '@/views/System/Permissions.vue'
import SystemConfig from '@/views/System/Config.vue'
import DelegatedCompany from '@/views/DelegatedCompany/index.vue'
import DelegatedAccount from '@/views/DelegatedAccount/index.vue'
import Distributors from '@/views/Distributors/index.vue'
import Flow from '@/views/Flow/index.vue'
import NoPermission from '@/views/Error/NoPermission.vue'

// meta.permission 必须与后台「权限管理」(manger_permissions.slug) 一致，
// 取值可以是字符串或数组（数组表示任一权限即可）。
// 没有配置 permission 的路由只要求登录，不做菜单权限校验
// （例如订单详情/售后详情这类隐藏页，以及权限表里暂未建节点的页面）。
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '首页数据', icon: 'el-icon-s-data', permission: 'dashboard' }
      },
      {
        path: 'products',
        name: 'Products',
        component: Products,
        meta: { title: '普惠商品管理', icon: 'el-icon-goods', permission: 'products' }
      },
      {
        path: 'review',
        name: 'Review',
        component: Review,
        meta: { title: '商品审核', icon: 'el-icon-document-checked', permission: 'review' }
      },
      {
        path: 'orders/puhui',
        name: 'PuhuiOrders',
        component: PuhuiOrders,
        meta: { title: '普惠订单', icon: 'el-icon-s-order', permission: 'orders.puhui' }
      },
      {
        path: 'orders/report',
        name: 'ReportOrders',
        component: ReportOrders,
        meta: { title: '甄选/爆品订单', icon: 'el-icon-tickets', permission: 'orders.report' }
      },
      {
        path: 'orders/detail/:orderNo',
        name: 'OrderDetail',
        component: OrderDetail,
        meta: { title: '订单详情', hidden: true, permission: ['orders.puhui', 'orders.report'] }
      },
      {
        path: 'members',
        name: 'Members',
        component: Members,
        meta: { title: '全平台会员', icon: 'el-icon-user-solid', permission: 'members' }
      },
      {
        path: 'accounts',
        name: 'Accounts',
        component: Accounts,
        meta: { title: '分身账号管理', icon: 'el-icon-key', permission: 'accounts' }
      },
      {
        path: 'finance',
        name: 'Finance',
        component: Finance,
        meta: { title: '平台财务', icon: 'el-icon-money', permission: 'finance' }
      },
      {
        path: 'leaderboard',
        name: 'Leaderboard',
        component: Leaderboard,
        meta: { title: '龙虎榜', icon: 'el-icon-trophy', permission: 'leaderboard' }
      },
      {
        path: 'flow',
        name: 'Flow',
        component: Flow,
        meta: { title: '今日流水', icon: 'el-icon-data-line' }
      },
      {
        path: 'merchant-audit',
        name: 'MerchantAudit',
        component: MerchantAudit,
        meta: { title: '会员商户信息审核', icon: 'el-icon-s-check', permission: 'merchant-audit' }
      },
      {
        path: 'after-sales',
        name: 'AfterSales',
        component: AfterSales,
        meta: { title: '售后管理', icon: 'el-icon-service' }
      },
      {
        path: 'after-sales/:id',
        name: 'AfterSaleDetail',
        component: AfterSaleDetail,
        meta: { title: '售后详情', hidden: true }
      },
      {
        path: 'cloud-warehouse',
        name: 'CloudWarehouse',
        component: CloudWarehouse,
        meta: { title: '托管商品管理', icon: 'el-icon-box', permission: 'cloud-warehouse' }
      },
      {
        path: 'delegated-companies',
        name: 'DelegatedCompany',
        component: DelegatedCompany,
        meta: { title: '可委托公司管理', icon: 'el-icon-office-building', permission: 'delegated-companies' }
      },
      {
        path: 'delegated-accounts',
        name: 'DelegatedAccount',
        component: DelegatedAccount,
        meta: { title: '委托账户', icon: 'el-icon-coin', permission: 'delegated-accounts' }
      },
      {
        path: 'distributors',
        name: 'Distributors',
        component: Distributors,
        meta: { title: '供货商管理', icon: 'el-icon-s-cooperation', permission: 'distributors' }
      },
      // RBAC 系统管理
      {
        path: 'system/admins',
        name: 'SystemAdmins',
        component: SystemAdmins,
        meta: { title: '管理员管理', icon: 'el-icon-user', permission: 'system.admins' }
      },
      {
        path: 'system/roles',
        name: 'SystemRoles',
        component: SystemRoles,
        meta: { title: '角色管理', icon: 'el-icon-s-custom', permission: 'system.roles' }
      },
      {
        path: 'system/permissions',
        name: 'SystemPermissions',
        component: SystemPermissions,
        meta: { title: '权限管理', icon: 'el-icon-lock', permission: 'system.permissions' }
      },
      {
        path: 'system/config',
        name: 'SystemConfig',
        component: SystemConfig,
        meta: { title: '系统配置', icon: 'el-icon-setting', permission: 'system.config' }
      },
      {
        path: '403',
        name: 'NoPermission',
        component: NoPermission,
        meta: { title: '无访问权限', hidden: true }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

/**
 * 判断当前账号是否拥有目标路由要求的权限
 */
function hasRoutePermission(to) {
  // 未绑定角色的超级管理员不受权限限制
  if (store.state.isSuper) {
    return true
  }
  const required = to.meta && to.meta.permission
  if (!required) {
    return true
  }
  const owned = store.state.permissions || []
  const need = Array.isArray(required) ? required : [required]
  return need.some((slug) => owned.includes(slug))
}

// 登录守卫 + 用户信息获取 + 菜单权限校验
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')

  if (!token) {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
    return
  }

  // 已登录还访问登录页：直接进第一个有权限的菜单
  if (to.path === '/login') {
    next(store.getters.firstAccessiblePath || '/403')
    return
  }

  const afterUserInfo = () => {
    // 根路径：跳第一个有权限的菜单（没有首页权限就不会进首页）
    if (to.path === '/') {
      next(store.getters.firstAccessiblePath || '/403')
      return
    }

    if (!hasRoutePermission(to)) {
      next('/403')
      return
    }

    next()
  }

  if (!store.state.userInfoLoaded) {
    store.dispatch('fetchUserInfo').then(() => {
      afterUserInfo()
    }).catch(() => {
      // 拉取用户信息失败（token 失效等）：清掉本地 token 回登录页，避免死循环
      localStorage.removeItem('admin_token')
      next('/login')
    })
  } else {
    afterUserInfo()
  }
})

export default router
